import { Canvas } from "@react-three/fiber";
import { Experience } from "./components/Experience"
import { useState, useEffect, Suspense } from "react"
import { UI } from "./components/UI";
import { Loader, useProgress } from "@react-three/drei"
import { UITransition } from "./components/UITransition"
import * as THREE from "three"


function App() {
  const [portalState, setPortalState] = useState(3)
  const [lunchAnimation, setLunchAnimation] = useState(false)
  const [startExperience, setStartExperience] = useState(false)
  const [helpState, setHelpState] = useState(false)
  const [contactState, setContactState] = useState(false)
  const [contactPage, setContactPage] = useState(0)
  const [clickedbyHam, setCLickedByHam] = useState(false)
  const { active, progress, errors, item, loaded, total } = useProgress()

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    // Smooth scroll for the entire app
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Or reset scroll position on app load
    window.scrollTo(1, 0);
    
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth < 768)
    checkIsMobile()
    window.addEventListener('resize', checkIsMobile)
    return () => window.removeEventListener('resize', checkIsMobile)
  }, [])

  return (
    <div style={{ height: "100vh", width: "100vw", margin: 0, padding: 0 }}>
      <Loader 
        containerStyles={{ backgroundColor: '#271a12' }}
        innerStyles={{ 
          backgroundColor: '#ffefec', 
          width: '100%',
          height: '30px',
          borderRadius: '30px',
        }}
        barStyles={{ backgroundColor: '#e66b24', borderRadius: '30px', height: '30px', width: '100%' }}
        dataStyles={{ color: '#fff', fontSize: '1.2em' }}
        dataInterpolation={(p) => `Will be ready in a moment ...`}
      >
        <img
          src="./assets/react.svg"
          alt="Logo"
          style={{
            width: "100px",
            marginBottom: "20px",
          }}
        />
      </Loader>

      <Canvas
        style={{ height: "100%", width: "100%" }}
        camera={{ position: [0, 0, 0], fov: 40 }}
        dpr={[1, 2]}
        gl={{
          antialias: true,
          toneMapping: THREE.ACESFilmicToneMapping
        }}
      >
        <Suspense>
          <UITransition
            isMobile={isMobile}
            setIsMobile={setIsMobile}
            startExperience={startExperience}
            setStartExperience={setStartExperience}
          />
        </Suspense>

        <Experience
          lunchAnimation={lunchAnimation}
          setLunchAnimation={setLunchAnimation}
          isMobile={isMobile}
          setIsMobile={setIsMobile}
          portalState={portalState}
          setPortalState={setPortalState}
          startExperience={startExperience}
          helpState={helpState}
          setHelpState={setHelpState}
          contactState={contactState}
          setContactState={setContactState}
          contactPage={contactPage}
          setContactPage={setContactPage}
          setCLickedByHam={setCLickedByHam}
          clickedbyHam={clickedbyHam}
        />
      </Canvas>

      <Suspense>
        <UI
          lunchAnimation={lunchAnimation}
          setLunchAnimation={setLunchAnimation}
          portalState={portalState}
          setPortalState={setPortalState}
          startExperience={startExperience}
          setStartExperience={setStartExperience}
          setHelpState={setHelpState}
          helpState={helpState}
          contactState={contactState}
          setContactState={setContactState}
          contactPage={contactPage}
          setContactPage={setContactPage}
          setCLickedByHam={setCLickedByHam}
          clickedbyHam={clickedbyHam}
          isMobile={isMobile}
        />
      </Suspense>
    </div>
  );
}

export default App;